module.exports = __webpack_public_path__ + "static/media/logopisb.1e08728f.png";